import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export const ENCOMPASS_FIELD_KIND = {
  STANDARD: 'standard',
  CUSTOM: 'custom',
} as const;

export type EncompassFieldKind =
  (typeof ENCOMPASS_FIELD_KIND)[keyof typeof ENCOMPASS_FIELD_KIND];

export const ENCOMPASS_FIELD_KIND_VALUES = [
  ENCOMPASS_FIELD_KIND.STANDARD,
  ENCOMPASS_FIELD_KIND.CUSTOM,
] as const;

export const isCustomEncompassFieldKind = (
  kind: unknown,
): kind is typeof ENCOMPASS_FIELD_KIND.CUSTOM =>
  kind === ENCOMPASS_FIELD_KIND.CUSTOM;

export const getEncompassFieldKind = (kind?: unknown): EncompassFieldKind =>
  isCustomEncompassFieldKind(kind)
    ? ENCOMPASS_FIELD_KIND.CUSTOM
    : ENCOMPASS_FIELD_KIND.STANDARD;

export interface EncompassCustomField {
  id: string;
  source_field_id: string;
  fieldKind: typeof ENCOMPASS_FIELD_KIND.CUSTOM;
  instanceId: string;
  description?: string;
  jsonPath?: string;
  contractPath?: string;
  dataType: string;
  format?: string;
  maxLength?: number;
  options?: Array<{ value: string; text: string }> | null;
  isCalculated?: boolean | null;
  definitionFetchedAt: string;
}
export interface EncompassCustomFieldsResponse {
  success: boolean;
  fields: EncompassCustomField[];
}
export const ENCOMPASS_CUSTOM_FIELDS_QUERY_KEY = [
  '/encompass/custom-fields',
] as const;

export default async function getEncompassCustomFields(
  options: { fieldIds?: string; search?: string; signal?: AbortSignal } = {},
): Promise<EncompassCustomFieldsResponse> {
  const params = new URLSearchParams();
  if (options.fieldIds) params.set('fieldIds', options.fieldIds);
  if (options.search) params.set('search', options.search);
  const http = await getCompatibleAuthTokenHttp();
  const response = await http<EncompassCustomFieldsResponse>(
    '/encompass/custom-fields' + (params.size ? '?' + params.toString() : ''),
    { method: 'GET', signal: options.signal },
  );
  if (response.data?.success) return response.data;
  throw new Error('Failed to fetch Encompass custom fields');
}
